import {Separator} from 'platform/components';
import {HStack, Text, VStack} from 'platform/foundation';

import {Fragment, useMemo} from 'react';

import {isEmpty, isNil, isNotEmpty} from 'ramda';

import {TestIdProps} from 'shared/web';

import {Flag} from '../../../../../components/Flag/Flag';
import {useCatalogue} from '../../../../../hooks/useCatalogue';
import i18n from '../../../../../i18n/i18n';
import {EquipmentCategoryRange} from '../types/EquipmentCategoryRange';
import {EqupimentCategory} from './EqupimentCategory';

interface EquipmentProps extends TestIdProps {
  equipmentCategories?: EquipmentCategoryRange[];
}

export function MostEquipedEquipment(props: EquipmentProps) {
  const {hasFeatureTranslation} = useCatalogue();

  const filteredEquipmentCategories = useMemo(
    (): EquipmentCategoryRange[] | undefined =>
      props.equipmentCategories
        ?.map((category) => ({
          ...category,
          flags: category.flags.filter((item) => hasFeatureTranslation(item.feature)),
        }))
        .filter((category) => isNotEmpty(category.flags)),
    [props.equipmentCategories, hasFeatureTranslation]
  );

  if (isNil(filteredEquipmentCategories) || isEmpty(filteredEquipmentCategories)) {
    return null;
  }

  return (
    <VStack spacing={6}>
      <HStack align="center" justify="center" spacing={2} wrap>
        <Text size="xSmall" color="secondary">
          {i18n.t('entity.overviewEquipment.labels.legend')}:
        </Text>
        <Flag
          backgroundColor="palettes.blue.30.100"
          color="palettes.blue.80.100"
          size="small"
          label={i18n.t('entity.overviewEquipment.labels.availableHighlightFeature')}
        />
        <Flag
          backgroundColor="palettes.blue.10.100"
          color="palettes.blue.80.100"
          size="small"
          label={i18n.t('entity.overviewEquipment.labels.availableFeature')}
        />
        <Flag
          backgroundColor="palettes.red.30.100"
          color="palettes.red.90.100"
          size="small"
          label={i18n.t('entity.overviewEquipment.labels.missingHighlightFeature')}
        />
        <Flag
          backgroundColor="palettes.red.10.100"
          color="palettes.red.80.100"
          size="small"
          label={i18n.t('entity.overviewEquipment.labels.missingFeature')}
        />
      </HStack>
      <VStack>
        {filteredEquipmentCategories.map((category, index) => (
          <Fragment key={`${category.minShare ?? 'min'}-${category.maxShare ?? 'max'}`}>
            {index > 0 && <Separator orientation="horizontal" spacing={4} />}
            <EqupimentCategory
              flags={category.flags}
              minShare={category.minShare}
              maxShare={category.maxShare}
              data-testid={props['data-testid']}
            />
          </Fragment>
        ))}
      </VStack>
    </VStack>
  );
}
